import { provideWidgetClass } from 'scrivito'

import { DXPDashboardWidgetClass } from './const'

/**
 * the Dashboard widget
 */
export const DXPDashboardWidget = provideWidgetClass(DXPDashboardWidgetClass, {
  attributes: {},
})

/**
 * dashboard widget type
 */
export type DXPDashbaordWidgetType = InstanceType<typeof DXPDashboardWidget>
